import { UserStatusState } from '@modules/UserStatusModule/types';
import { proxy } from 'valtio';
import { valtioDevTools } from '@lib/utils/devTools';

/**
 * Defines the global state for UserStatusModule-specific data.
 */
export const userStatusState = proxy<UserStatusState>({
  recoveryTimeEndsAt: undefined,
  refreshUserStatusLoading: false,
});

valtioDevTools(userStatusState, 'userStatusState');
